export function onLoadCaptchaCallback() {
    //  console.log('Captcha2 onLoadCaptchaCallback');
}

const TRUE_VALUES = new Set(['y', 'yes', 't', 'true', '1']);
const FALSE_VALUES = new Set(['n', 'no', 'f', 'false', '0']);

/**
 * Parses a truthy/falsy flag value (as sent by the server) into a boolean.
 * Accepts Y/N, Yes/No, T/F, True/False, 1/0 — case-insensitive, whitespace-trimmed.
 * Also accepts native booleans. Any unrecognized value returns `defaultValue`.
 *
 * @param {*} value        the flag to parse (e.g. 'Y', 'no', true)
 * @param {boolean} [defaultValue=false] returned when value is null/undefined/unrecognized
 * @returns {boolean}
 */
export function parseBool(value, defaultValue = false) {
    if (typeof value === 'boolean') return value;
    if (value === null || value === undefined) return defaultValue;
    const v = String(value).trim().toLowerCase();
    if (TRUE_VALUES.has(v)) return true;
    if (FALSE_VALUES.has(v)) return false;
    return defaultValue;
}

/** True only when `value` explicitly parses to a truthy flag (Y/Yes/T/True/1). */
export function isYes(value) {
    return parseBool(value, false) === true;
}

/** True only when `value` explicitly parses to a falsy flag (N/No/F/False/0). */
export function isNo(value) {
    if (typeof value === 'boolean') return value === false;
    if (value === null || value === undefined) return false;
    return FALSE_VALUES.has(String(value).trim().toLowerCase());
}

